export default __webpack_public_path__ + "static/media/texas-solar-bg1.d34f0436.jpg";